var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagTitleAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8335 9.16683H10.8335V4.16683C10.8335 3.94582 10.7457 3.73385 10.5894 3.57757C10.4331 3.42129 10.2212 3.3335 10.0002 3.3335C9.77915 3.3335 9.56719 3.42129 9.41091 3.57757C9.25463 3.73385 9.16683 3.94582 9.16683 4.16683V9.16683H4.16683C3.94582 9.16683 3.73385 9.25463 3.57757 9.41091C3.42129 9.56719 3.3335 9.77915 3.3335 10.0002C3.3335 10.2212 3.42129 10.4331 3.57757 10.5894C3.73385 10.7457 3.94582 10.8335 4.16683 10.8335H9.16683V15.8335C9.16683 16.0545 9.25463 16.2665 9.41091 16.4228C9.56719 16.579 9.77915 16.6668 10.0002 16.6668C10.2212 16.6668 10.4331 16.579 10.5894 16.4228C10.7457 16.2665 10.8335 16.0545 10.8335 15.8335V10.8335H15.8335C16.0545 10.8335 16.2665 10.7457 16.4228 10.5894C16.579 10.4331 16.6668 10.2212 16.6668 10.0002C16.6668 9.77915 16.579 9.56719 16.4228 9.41091C16.2665 9.25463 16.0545 9.16683 15.8335 9.16683Z",
    fill: "url(#paint0_linear_834_502)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_834_502",
    x1: 3.3335,
    y1: 10.0002,
    x2: 16.6668,
    y2: 10.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#3154C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3153C7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagTitleAdd);
export default __webpack_public_path__ + "static/media/tagTitleAdd.b06c7ee89330c19b22497bb1df35c94a.svg";
export { ForwardRef as ReactComponent };